/**
 * @fileoverview Pantalla 8 — Salida sin completar.
 * Mensaje tranquilizador + botón para volver al inicio.
 */

import { Save } from "lucide-react";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { AppShell } from "../components/AppShell";
import { Button } from "../components/ui/button";
import { useParticipacion, useLimpiarSesion } from "../context/ParticipacionContext";

export function Salida() {
    const navigate = useNavigate();
    const { state } = useParticipacion();
    const limpiar = useLimpiarSesion();

    const total = useMemo(() => Object.keys(state.votos).length, [state.votos]);

    function handleVolver() {
        // Quitamos memoria pero NO el sessionStorage del codigo, porque
        // queremos que pueda regresar fácil si solo recargó.
        // En realidad el participante puede simplemente reescribir su
        // código en /, así que limpiamos por completo.
        limpiar();
        navigate("/", { replace: true });
    }

    return (
        <AppShell testid="page-salida">
            <div className="space-y-6 text-center sm:text-left">
                <div className="inline-flex w-12 h-12 rounded-full bg-accent/10 items-center justify-center">
                    <Save className="text-accent" size={22} />
                </div>
                <div className="space-y-3">
                    <h1 className="font-serif-headline text-2xl sm:text-3xl font-semibold text-foreground">
                        Tus respuestas se guardaron
                    </h1>
                    <p className="text-base text-muted-foreground leading-relaxed">
                        Has guardado <strong className="text-foreground">{total}</strong>{" "}
                        respuestas. Puedes volver con tu mismo código{" "}
                        <span className="font-mono font-semibold text-foreground">
                            {state.codigo || "XXX-NNNN"}
                        </span>{" "}
                        cuando quieras para continuar antes de que cierre el foro.
                    </p>
                </div>

                <Button
                    size="lg"
                    onClick={handleVolver}
                    className="w-full sm:w-auto h-12 font-semibold"
                    data-testid="volver-inicio-btn"
                >
                    Volver al inicio
                </Button>
            </div>
        </AppShell>
    );
}
